import React from 'react';
import styled from 'styled-components';

import { H3 } from '@ad-scripts/presentation/components/common/headers';

export const Header = ({ headerText }) => {
  return (
    <StyledHeader>
      <HeaderText>{headerText}</HeaderText>
    </StyledHeader>
  );
};

const StyledHeader = styled(H3)`
  color: ${p => p.theme.colors.black};
  justify-content: start;
  line-height: 8px;
  margin-bottom: ${p => p.theme.spacing.insetSmall};
  margin-top: ${p => p.theme.spacing.insetSmall};
`;

export const StyledDescription = styled.div`
  font-size: 13px;
  line-height: 21px;
  margin-bottom: ${p => p.theme.spacing.insetSmall};
  margin-top: ${p => p.theme.spacing.insetSmall};
`;

const HeaderText = styled.span`
  padding-right: 6px;
`;

export default Header;
